import React, { Component } from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import TimeOptions from '../../Common/TimeOptions/TimeOptions';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import Help from '../../Common/Help/Help';
import TextareaCount from '../../Common/TextareaCount/TextareaCount';
import SingleDatePickerWrapper from '../../Common/SingleDatePickerWrapper/SingleDatePickerWrapper';
import ConstantsList from '../../Common/Constants/Constants';
import Message from '../../Common/Message/Message';
import en from './locales/en.json';
import fr from './locales/fr.json';

import './CouponForm.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class CouponForm extends Component {
    constructor(props) {
        super(props);
		this.state = { 
            selectedDays: {},
            videos: [],
        }
    }

    handleDayChange = (day, input) => {
        if(day !== undefined) {
            this.setState({
                selectedDays: day
            });
            this.props.handleChange(day, input.props.id);
        }
    }
    
    componentDidMount() {
        this.getAdminVideos();
    }

    getAdminVideos = () => {
        const getVideos = async () => {
            try {
                const videosResponse = await getVideosAPI();
                console.log('videosResponse: ', videosResponse);
                if (videosResponse.data) {
                    const videos = videosResponse.data;
                    this.setState({
                        videos,
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getVideosAPI() {
            return await ApiRequest('/admin/videos', {
                method: 'GET',
            });
        }
        getVideos();
    }

    render() {
        let couponType = this.props.couponDetails.couponType;
        let pageTitle = (this.props.couponExists) ? strings.title1Edit : strings.title1Create;
        const videos = this.state.videos;
		let videoUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
        videos.forEach((video) => {
            if (video.title.includes('Coupons')) {
                videoUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
			}
        });
        return (
            <div className="showtix-coupon-form">
                {!this.props.couponExists &&
                <div className="showtix-coupon-form__first-step showtix-section showtix-section__padding-1 showtix-background__primary-4">
                    <div className="container">
                        <h1>{pageTitle}</h1>
                        <div className="row">
                            <div className="col-12">
                                <h3 className="showtix-font-weight-light mb-3">{strings.subTitle}</h3>
                            </div>
                            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-0">
                                <button
                                    className="showtix-button showtix-background__primary-2"
                                    onClick={() => this.props.setCouponType('single')}
                                >
                                    <span>{strings.btnOneCoupon.text}</span>
                                    <span id="tooltip-btnOneCoupon" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-btnOneCoupon">
                                        {strings.btnOneCoupon.tooltip}
                                    </Tooltip>
                                </button>
                            </div>

                            <div className="col-12 col-md-6 col-lg-4">
                                <button className="showtix-button showtix-background__primary-2"
                                        onClick={() => this.props.setCouponType('multiple')}>
                                    <span>{strings.btnMultipleCoupon.text}</span>
                                    <span id="tooltip-btnMultipleCoupon" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-btnMultipleCoupon">
                                        {strings.btnMultipleCoupon.tooltip}
                                    </Tooltip>
                                </button>
                            </div>

                            { strings.headerHelp &&
                            <div className="col-12 col-md-12 col-lg-4">
                                <div className="showtix-box">
                                    <div className="showtix-padder">
                                        <h3 className="showtix-box__title">{strings.video.title}</h3>
                                        <p><a href={videoUrl} target="_blank" rel="noopener">{strings.video.content1}</a></p>
                                    </div>	
                                </div>
                                <Help help={strings.headerHelp} />
                            </div>
                            }
                        </div>
                    </div>
                </div>
                }

                <div className={this.props.isSecondStepOpen === true ? "showtix-coupon-form__second-step is-active" : "showtix-coupon-form__second-step"}>
                    <div className="showtix-section">
                        <div className="container">
                            <Message
                                message={this.props.message}
                            />
                            <div className="row">
                                <div className="col-12"><h1>{strings.title2}</h1></div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-lg-9">
                                    <div className="row">
                                        <div className="col-12 col-lg-6">
                                            <div className="showtix-form__group">
                                                <label className="showtix-label" htmlFor="couponName">{strings.couponName}
                                                    <span id="tooltip-couponName" className="showtix-tooltip">!</span>
                                                    <Tooltip placement="top" target="tooltip-couponName">
                                                        {strings.couponNameTooltip}
                                                    </Tooltip>
                                                </label>

                                                <div className="showtix-form__input">
                                                    <input
                                                        className="showtix-input"
                                                        type="text"
                                                        name="couponName"
                                                        id="couponName"
                                                        value={this.props.couponDetails.couponName}
                                                        onChange={this.props.handleChange}
                                                        onBlur={this.props.validateRequiredField}
                                                        required
                                                    />
                                                </div>
                                                {!this.props.validation[couponType].couponName.valid &&
                                                <div className="showtix-note error">
                                                    {this.props.validation[couponType].couponName.msg}
                                                </div>
                                                }
                                            </div>
                                        </div>

                                        {couponType === "single" &&
                                        <div className="col-12 col-lg-6">
                                            <div className={"showtix-form__group " + (this.props.validation[couponType].couponCode.valid === false && this.props.couponDetails.couponCode !== '' ? 'showtix-form__error' : '')}>
                                                <label className="showtix-label" htmlFor="couponCode">{strings.couponCode}
                                                    <span id="tooltip-couponCode" className="showtix-tooltip">!</span>
                                                    <Tooltip placement="top" target="tooltip-couponCode">
                                                        {strings.couponCodeTooltip}
                                                    </Tooltip>
                                                </label>

                                                <div className="coupon-code-wrapper">
                                                    <div className="showtix-form__input prefix">
                                                        <input
                                                            className="showtix-input"
                                                            type="text"
                                                            value="C-"
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="showtix-form__input field">
                                                        <input
                                                            className="showtix-input"
                                                            type="text"
                                                            name="couponCode"
                                                            id="couponCode"
                                                            value={this.props.couponDetails.couponCode}
                                                            onChange={this.props.handleChange}
                                                            onBlur={this.props.validateRequiredField}
                                                            validation={ConstantsList.REGEX.LETTERS_NUMBERS_UNDERSCORE_DASH}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                {!this.props.validation[couponType].couponCode.valid &&
                                                <div className="showtix-note error">
                                                    {this.props.validation[couponType].couponCode.msg}
                                                </div>
                                                }
                                            </div>
                                        </div>
                                        }
                                    </div>

                                    {couponType === "single" &&
                                    <div className="row">
                                        <div className="col-12 col-lg-6">
                                            <div className="showtix-form__group">
                                                <label className="showtix-label" htmlFor="nbRedemptionSingle">{strings.nbRedemption}
                                                    <span id="tooltip-nbRedemption" className="showtix-tooltip">!</span>
                                                    <Tooltip placement="top" target="tooltip-nbRedemption">
                                                        {strings.nbRedemptionTooltip}
                                                    </Tooltip>
                                                </label>

                                                <div className="showtix-form__input">
                                                    <input
                                                        className="showtix-input"
                                                        type="number"
                                                        name="nbRedemptionSingle"
                                                        id="nbRedemptionSingle"
                                                        value={this.props.couponDetails.nbRedemptionSingle}
                                                        onChange={this.props.handleChange}
                                                        onBlur={this.props.validateRequiredField}
                                                        required
                                                    />
                                                </div>
                                                {!this.props.validation[couponType].nbRedemptionSingle.valid &&
                                                <div className="showtix-note error">
                                                    {this.props.validation[couponType].nbRedemptionSingle.msg}
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    }

                                    {couponType === "multiple" &&
                                    <div className="row nb-redemption">
                                        <div className="col-12">
                                            <div className="showtix-form__group">
                                                <div className="showtix-form__input">
                                                    <span>{strings.nbRedemption1}</span>
                                                    <input
                                                        className="showtix-input"
                                                        type="number"
                                                        name="nbRedemptionMultiple"
                                                        value={this.props.couponDetails.nbRedemptionMultiple}
                                                        onChange={this.props.handleChange}
                                                        onBlur={this.props.validateRequiredField}
                                                        required
                                                    />
                                                    <span>{strings.nbRedemption2}</span>
                                                </div>
                                                {!this.props.validation[couponType].nbRedemptionMultiple.valid &&
                                                <div className="showtix-note error">
                                                    {this.props.validation[couponType].nbRedemptionMultiple.msg}
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    }

                                    <hr className="color-1" />
                                    <div className="row">
                                        <div className="col-12 col-lg-6">
                                            <div className="row">
                                                <div className="col-12 col-lg-4">
                                                    <div className="showtix-form__group">
                                                        <label className="showtix-label" htmlFor="couponValue">
                                                            {strings.value}
                                                        </label>
                                                        <div className="showtix-form__input">
                                                            <input
                                                                className="showtix-input"
                                                                type="number"
                                                                name="couponValue"
                                                                id="couponValue"
                                                                value={this.props.couponDetails.couponValue}
                                                                onChange={this.props.handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-lg-8">
                                                    <div className="showtix-form__group">
                                                        <label className="showtix-label empty">&nbsp;</label>
                                                        <div className="showtix-form__select">
                                                            <select className="showtix-input"
                                                                    name="couponValueType"
                                                                    onChange={this.props.handleChange}
                                                                    value={this.props.couponDetails.couponValueType}
                                                            >
                                                                {strings.couponTypes.length &&
                                                                [
                                                                    (strings.couponTypes.map((option, i) =>
                                                                        <option
                                                                            key={i}
                                                                            value={option.value}
                                                                        >{option.type}</option>
                                                                    ))
                                                                ]
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="showtix-form__group">
                                                        <label className="showtix-label" htmlFor="couponStartDate">
                                                            {strings.startDate} *
                                                        </label>
                                                        <div className="showtix-form__multiple">
                                                            <div className="showtix-form__input">
                                                                <SingleDatePickerWrapper
                                                                    id="couponStartDate"
                                                                    handleDayChange={this.handleDayChange}
                                                                    selectedDays={this.props.couponDetails.couponStartDate}
                                                                    disablePrevious={true}
                                                                />
                                                            </div>
                                                            <div className="showtix-form__select">
                                                                <select className="showtix-input"
                                                                        name="couponStartTime"
                                                                        onChange={this.props.handleChange}
                                                                        value={this.props.couponDetails.couponStartTime}
                                                                >
                                                                    <TimeOptions />
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="showtix-form__group">
                                                        <label className="showtix-label" htmlFor="couponEndDate">
                                                            {strings.endDate} *
                                                        </label>
                                                        <div className="showtix-form__multiple">
                                                            <div className="showtix-form__input">
                                                                <SingleDatePickerWrapper
                                                                    id="couponEndDate"
                                                                    handleDayChange={this.handleDayChange}
                                                                    selectedDays={this.props.couponDetails.couponEndDate}
                                                                    disablePrevious={true}
                                                                />
                                                            </div>

                                                            <div className="showtix-form__select">
                                                                <select className="showtix-input"
                                                                        name="couponEndTime"
                                                                        onChange={this.props.handleChange}
                                                                        value={this.props.couponDetails.couponEndTime}
                                                                >
                                                                    <TimeOptions />
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            <div className="showtix-form__group">
                                                <label className="showtix-label" htmlFor="couponDescription">
                                                    {strings.description.label}
                                                </label>

                                                <TextareaCount
                                                    id="couponDescription"
                                                    maxLength="150"
                                                    handleChange={this.props.handleChange}
                                                    name="couponDescription"
                                                    value={this.props.couponDetails.couponDescription}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                { strings.help &&
                                <div className="col-12 col-lg-3">
                                    <Help help={strings.help} />
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

CouponForm.propTypes = {
    couponDetails: PropTypes.shape({
        couponType: PropTypes.string,
        couponName: PropTypes.string,
        couponCode: PropTypes.string,
        nbRedemptionSingle: PropTypes.string,
        nbRedemptionMultiple: PropTypes.string,
        couponValue: PropTypes.string,
        couponValueType: PropTypes.string,
        couponStartDate: momentPropTypes.momentObj,
        couponStartTime: PropTypes.string,
        couponEndDate: momentPropTypes.momentObj,
        couponEndTime: PropTypes.string,
        couponDescription: PropTypes.string
    }),
    validation: PropTypes.shape({
        single: PropTypes.shape({
            couponName: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            couponCode: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            nbRedemptionSingle: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            })
        }),
        multiple: PropTypes.shape({
            couponName: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            couponCode: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            nbRedemptionMultiple: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            })
        })
    }),
    isReadyToSubmit: PropTypes.bool,
    handleChange: PropTypes.func,
    validateRequiredField: PropTypes.func,
    saveCoupon: PropTypes.func,
}
 
export default CouponForm;


// WEBPACK FOOTER //
// ./src/components/CreateCoupon/CouponForm/CouponForm.js